define([
	"dojo/_base/declare",
	"./ActualGap"
], function(declare,ActualGap) {

	return declare(ActualGap, {
		// disable highlighting
		highlightSetting: "",

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return difference between actual and revised value
			var	actual = this._getActual(ctx);
			if (actual == this.DEFAULT) {
				return actual;
			}

			var	pattern = this._getReviewDimension(ctx).Pattern;
			if (pattern == this.DEFAULT) {
				return pattern;
			}

			return this._gap(pattern, actual);
		}
	});
});